module.exports = __webpack_public_path__ + "static/media/c12_5.58da43ad.png";